import ResponsibleInfo from './responsible-info';

export default ResponsibleInfo;